export function fnCompare<T>(fn, compare: (x: T | T[], y: T | T[]) => boolean) {
  return (x: T | T[], y: T | T[]): boolean => compare(fn(x), fn(y)); // tslint:disable-line:ban
}
